<template src="./Back.html"></template>

<script>

export default {
  name: 'back',
  props: ['link'],
  data () {
    return {
      
    }
  },
  mounted: function() {
    
  },
  watch: {
    
  },
  beforeRouteUpdate (to, from, next) {
    
  },
  methods: {
    redirect: function() {
      this.$router.push(this.link)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Back.vue?372b6b43